<template>
    <div v-if="model && form">
        <rkm-area
            title="Filtros"
            type="fieldset"
            no-margin-top
        >
            <rkm-form
                ref="Form"
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-date-picker
                            label="Data inicial"
                            v-model="model.dataInicial"
                            :validations="validations.dataInicial"
                            :max-date="model.dataFinal"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-date-picker
                            label="Data final"
                            v-model="model.dataFinal"
                            :validations="validations.dataFinal"
                            :min-date="model.dataInicial"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-select
                            label="Unidade"
                            :options="form.unidades"
                            show-default-option
                            default-option-text="Todas"
                            v-model="model.unidade"
                            text-field="nomeFantasia"
                            value-field="id"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-form-select
                            label="Profissional"
                            :options="form.profissionais"
                            show-default-option
                            default-option-text="Todos"
                            v-model="model.profissional"
                            text-field="nome"
                            value-field="id"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-button
                            @click="list"
                            :label="false"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            @click="resetForm"
                            :label="false"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
            v-if="items.length"
        >
            <rkm-table
                :fields="fields"
                :items="items"
                hide-filters
                hide-pagination
                no-footer-sorting
            >

                <template v-slot:cell(data)="row">
                    {{ row.value | formatDate }}
                </template>

                <template v-slot:cell(dataExportacao)="{ item }">

                    <span v-if="item.dataExportacao">
                        {{ item.dataExportacao }} às {{ item.horarioExportacao }} - {{ item.profissionalExportacao }}
                    </span>
                    <span v-else>-</span>
                </template>

                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        @click="show(item.id)"
                        color="primary"
                        title="Visualizar"
                        small
                    >
                        <rkm-icon icon="search" />
                    </rkm-button>

                    <rkm-button
                        @click="handleDelete(item.id)"
                        color="danger"
                        title="Deletar"
                        small
                        :disabled="item.exportado == true"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
import { repository, error } from '@/mixins';
import formats from '@/filters/formats'
import { mapActions } from "vuex";
import moment from 'moment'

export default {
    filters: {
        formatDate: formats.formatDate,
    },
    created() {
        this.repositories = {
            fichaVacinacao: this.getConectaSusRepository('atencaoBasica.fichaVacinacao'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }
        this.load()
    },
    computed: {
        validations() {
            return {
                dataInicial: {
                    required: true
                },
                dataFinal: {
                    required: true
                }
            }
        },
        fields() {
            return [
                {
                    key: "data",
                    label: "Data",
                    fixed: true
                },
                {
                    key: "profissional",
                    label: "Profissional",
                    fixed: true
                },
                {
                    key: "unidade",
                    label: "Unidade",
                    fixed: true
                },
                {
                    key: 'dataExportacao',
                    label: 'Exportação',
                    fixed: true
                },
                {
                    name: 'actions',
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    data() {
        return {
            model: null,
            form: null,
            items: [],
        }
    },
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        load() {
            this.setLoading()
            this.repositories.fichaVacinacao.index()
                .then(({ data }) => {
                    this.model = data.model
                    this.form = data.form
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        list() {
            this.$refs.Form.validate()
                .then(valid => {
                    if(!valid) return

                    this.setLoading()
                    this.repositories.fichaVacinacao.list({
                        data_inicial: moment(this.model.dataInicial).format('YYYY-MM-DD'),
                        data_final: moment(this.model.dataFinal).format('YYYY-MM-DD'),
                        unidade_id: this.model.unidade ?? null,
                        profissional_id: this.model.profissional ?? null,
                    })
                        .then(({ data }) => {
                            this.items = data
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        resetForm() {
            this.model.dataInicial = null
            this.model.dataFinal = null
            this.model.unidade = null
            this.model.profissional = null
            this.items = []
            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        getUnidades() {
            this.setLoading()
            this.repositories.fichaVacinacao.getUnidades({
                data_inicial: moment(this.model.dataInicial).format('YYYY-MM-DD'),
                data_final: moment(this.model.dataFinal).format('YYYY-MM-DD'),
            })
                .then(({ data }) => {
                    this.form.unidades = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getProfissionais() {
            this.setLoading()
            this.repositories.fichaVacinacao.getProfissionais({
                data_inicial: moment(this.model.dataInicial).format('YYYY-MM-DD'),
                data_final: moment(this.model.dataFinal).format('YYYY-MM-DD'),
                unidade_id: null
            })
                .then(({ data }) => {
                    this.form.profissionais = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        show(id) {
            this.$router.push({ name: 'atencao-basica-ficha-vacinacao-edit', params: { id } })
        },
        handleDelete(id) {
            const destroy = async () => {
                this.setLoading()
                this.repositories.fichaVacinacao.destroy(id)
                    .then(() => {
                        this.items = this.items.filter(item => item.id != id)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
            this.showDeleteConfirmation(
                'Deseja realmente excluir a ficha de vacinação?',
                destroy,
                this.handleError
            )
        }
    },
    watch: {
        "model.dataInicial" () {
            if(this.model.dataFinal && this.model.dataInicial) {
                this.getUnidades()
            }
        },
        "model.dataFinal" () {
            if(this.model.dataInicial && this.model.dataFinal) {
                this.getUnidades()
            }
        },
        "model.unidade" () {
            if(this.model.dataInicial && this.model.dataFinal && this.model.unidade) {
                this.getProfissionais()
            }
        }
    },
    mixins: [ repository, error ]
}
</script>